import React from 'react';
import { FiExternalLink, FiMail, FiX } from 'react-icons/fi';
import { useLanguage } from '../../contexts/LanguageContext';
import { getQuestionHeading } from '../../seo/contentMetadata';
import ContentDate from '../common/ContentDate';
import SafeIcon from '../common/SafeIcon';

const SOCIAL_LINKS = [
  {
    label: 'Threads',
    href: 'https://www.threads.com/@homy.hk',
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/homy.hk',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61578745554661',
  },
];

const AboutModal = ({ onClose }) => {
  const { language } = useLanguage();
  const heading = getQuestionHeading('about.title', language);

  return (
    <article
      className="about-modal-content"
      aria-labelledby="about-modal-heading"
      itemScope
      itemType="https://schema.org/Article"
    >
      <header className="modal-header-sticky">
        <div>
          <h2 id="about-modal-heading" itemProp="headline">
            {heading}
          </h2>
        </div>
        <button
          type="button"
          className="about-close-button"
          onClick={onClose}
          aria-label="關閉關於我們"
        >
          <SafeIcon icon={FiX} />
        </button>
      </header>

      <ContentDate />

      <div itemProp="articleBody">
        <section className="about-section">
          <h3>這個網站由誰營運？</h3>
          <p>
            木魚敲擊遊戲由香港的 Homy Tech Limited 設計、開發及維護。我們希望以簡單、友善且尊重文化的方式，
            提供適合日常放鬆與輕鬆遊玩的瀏覽器體驗。
          </p>
        </section>

        <section className="about-section">
          <h3>這個遊戲提供什麼？</h3>
          <p>
            玩家可以免費敲擊虛擬木魚、選擇不同祈福類型、累積連擊與成就，
            並解鎖多款特殊木魚。遊戲免下載、免註冊，進度保存在目前使用的瀏覽器。
          </p>
        </section>

        <section className="about-section">
          <h3>如何聯絡我們？</h3>
          <p>
            如有意見、合作建議或技術問題，歡迎透過電郵與我們聯絡。
          </p>
          <a
            className="about-contact-link"
            href="mailto:support@homy.hk"
          >
            <SafeIcon icon={FiMail} />
            support@homy.hk
          </a>
        </section>
      </div>

      <nav
        className="about-social-list"
        aria-label="Homy Tech 社群平台"
      >
        {SOCIAL_LINKS.map((link) => (
          <a
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.label}
            <SafeIcon icon={FiExternalLink} />
          </a>
        ))}
      </nav>
    </article>
  );
};

AboutModal.managesContentDate = true;

export default AboutModal;